import { api } from "./icfApi";
import { icfUtilsURL, icfPlatformAgentsURL } from "../../constant";

/**
 * Converts a File to a base64 string
 */
export const fileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => {
      const result = reader.result;
      const base64 = result.split(",")[1];
      resolve(base64);
    };

    reader.onerror = (error) => reject(error);
    reader.readAsDataURL(file);
  });
};

/**
 * ICF Planner Trigger
 */
export const triggerICFPlanner = async (payload, signal) => {
  try {
    const response = await api.post(`${icfPlatformAgentsURL}/generate-icf/run`, payload, { signal });
    return response.data.response;
  } catch (error) {
    if (axios.isCancel?.(error) || error.name === "CanceledError" || err.code === "ERR_CANCELED") {
      console.warn("ICF Planner Generation request aborted");
      return; // exit silently
    }
    console.error("ICF Planner Trigger failed:", error);
    throw error;
  }
};

/**
 * Upload ICF File
 */
export const uploadICFFile = async (payload) => {
  try {
    const response = await api.post(`${icfUtilsURL}/icf-file-upload/run`, payload);
    return response.data.response;
  } catch (error) {
    console.error("ICF File Upload failed:", error);
    throw error;
  }
};

/**
 * Digitize ICF File
 */
export const digitizeICFFile = async (payload, signal) => {
  try {
    const response = await api.post(`${icfUtilsURL}/icf-file-digitization/run`, payload, { signal });
    return response.data.response;
  } catch (error) {
    if (axios.isCancel?.(error) || error.name === "CanceledError" || err.code === "ERR_CANCELED") {
      console.warn("Digitization request aborted");
      return; // exit silently
    }
    console.error("ICF File Digitization failed:", error);
    throw error;
  }
};

/**
 * Get ICF Digitization Percentage
 */
export const getICFDigitizationPercent = async (payload) => {
  try {
    const response = await api.post(`${icfUtilsURL}/get-digitization-percent/run`, payload);
    return response.data.response;
  } catch (error) {
    console.error("Get ICF Digitization Percent failed:", error);
    throw error;
  }
};

/**
 * Save Selected Section
 */
export const saveICFSelectedSection = async (payload) => {
  try {
    const response = await api.post(`${icfUtilsURL}/save-selected-section/run`, payload);
    return response.data.response;
  } catch (error) {
    console.error("Save Selected Section failed:", error);
    throw error;
  }
};

/**
 * Get Section Data
 */
export const getICFSectionData = async (payload) => {
  try {
    const response = await api.post(`${icfUtilsURL}/get-section-data/run`, payload);
    return response.data.response;
  } catch (error) {
    console.error("Get Section Data failed:", error);
    throw error;
  }
};

/**
 * Get Template List
 */
export const getICFTemplateList = async (payload) => {
  try {
    const response = await api.post(`${icfUtilsURL}/get-template-list/run`, payload);
    return response.data.response;
  } catch (error) {
    console.error("Get ICF Template List failed:", error);
    throw error;
  }
};

/**
 * Get Section Configured Dataset
 */
export const getICFSectionConfiguredDataset = async (payload) => {
  try {
    const response = await api.post(`${icfUtilsURL}/get-section-configured-dataset/run`, payload);
    return response.data.response;
  } catch (error) {
    console.error("Get ICF Section Configured Dataset failed:", error);
    throw error;
  }
};

/**
 * Save Generated Log
 */
export const saveICFGeneratedLog = async (payload) => {
  try {
    const response = await api.post(`${icfUtilsURL}/save-generated-log/run`, payload);
    return response.data.response;
  } catch (error) {
    console.error("Save ICF Generated Log failed:", error);
    throw error;
  }
};

/**
 * Get Generated Log
 */
export const getICFGeneratedLog = async (payload) => {
  try {
    const response = await api.post(`${icfUtilsURL}/get-log-generated/run`, payload);
    return response.data.response;
  } catch (error) {
    console.error("Get ICF Generated Log failed:", error);
    throw error;
  }
};

/**
 * Get Context Library
 */
export const getICFContextLib = async (payload, signal) => {
  try {
    const response = await api.post(`${icfUtilsURL}/get-context-lib/run`, payload, { signal });
    return response.data.response;
  } catch (error) {
    if (axios.isCancel?.(error) || error.name === "CanceledError" || err.code === "ERR_CANCELED") {
      console.warn("ICF Context Library request aborted");
      return; // exit silently
    }
    console.error("Get ICF Static Context Library failed:", error);
    throw error;
  }
};

/**
 * Get Study Procedure
 */
export const getStudyProcedure = async (payload, signal) => {
  try {
    const response = await api.post(`${icfUtilsURL}/get-study-procedure-content/run`, payload, { signal });
    return response.data.response;
  } catch (error) {
    if (axios.isCancel?.(error) || error.name === "CanceledError" || err.code === "ERR_CANCELED") {
      console.warn("ICF Study Procedure request aborted");
      return; // exit silently
    }
    console.error("Get ICF Study Procedure failed:", error);
    throw error;
  }
};
